export const interstateInputEventBuilder = (name, value, isValid, domEvent, label, messageKey, formattedValue) => {
  return {
    target: {
      name,
      label,
      value,
      formattedValue
    },
    isValid,
    domEvent,
    messageKey
  };
};